import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"user\">\n    <path d=\"M7 0C5.065 0 3.5 1.565 3.5 3.5S5.065 7 7 7s3.5-1.565 3.5-3.5S8.935 0 7 0zm0 8.75c-5.339 0-7 3.5-7 3.5V14h14v-1.75s-1.661-3.5-7-3.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol